import {
  DEFAULT_CONVERSATIONS_LIMIT,
  type FetchConversationsParams,
  getConversationHistoryApiConversationsGet,
} from "@noa/api-core";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../errors";
import { ConversationQueryKey } from "../../query-keys";

const fetchAllUserConversations = async (params: FetchConversationsParams = {}) => {
  const { limit = DEFAULT_CONVERSATIONS_LIMIT, offset = 0, filter = "", deleted = false, sort } = params;
  const { data } = await getConversationHistoryApiConversationsGet({
    query: {
      limit,
      offset,
      ...(filter ? { filter } : {}),
      ...(sort ? { sort } : {}),
      ...(deleted ? { deleted } : {}),
    },
    throwOnError: true,
  });
  return data;
};

export const useConversationsList = (params: FetchConversationsParams = {}) => {
  const { data, isLoading, isFetching, isError, error, ...rest } = useQuery<
    Awaited<ReturnType<typeof fetchAllUserConversations>>,
    ApiError
  >({
    queryKey: ConversationQueryKey.list(params),
    queryFn: () => fetchAllUserConversations(params),
  });

  return {
    conversations: data?.conversations ?? [],
    isLoadingConversations: isLoading,
    isFetchingConversations: isFetching,
    isErrorConversations: isError,
    errorConversations: error,
    ...rest,
  };
};
